module.exports = "<div class=\"card\" [ngClass]=\"{'is-collapsed': collapsed, 'active': !collapsed}\">\r\n  <ng-content></ng-content>\r\n</div>"